import React from "react";
import { useModal } from "@root/client/modal";
import { Props } from "./types";
import { Report } from "./report";
import styles from "./styles.scss";
import { UseCases } from "@planzone/core";

function ReportsList({ reports, indicatorsNames, project }: Props) {
  const { pushView } = useModal();
  return (
    <ul className={styles.reportsList}>
      {reports
        .sort((current, next) =>
          new Date(current.submissionDate) < new Date(next.submissionDate)
            ? 1
            : -1,
        )
        .map((report) => (
          <li
            onClick={() =>
              pushView({
                data: {
                  project: project,
                  reportId: report.uuid,
                },
                key: UseCases.retrieveProjectReport,
              })
            }
            key={report.uuid}
            className={styles.report}
          >
            <Report report={report} indicatorsNames={indicatorsNames} />
          </li>
        ))}
    </ul>
  );
}

export { ReportsList };
